import { LoginApiResult } from '@/libs/sdk/api';
import { createContext, MouseEvent, useContext } from 'react';

export interface AuthInterface {
  isAuthed: boolean;
  isAuthLoading: boolean;
  /** Real wallet connectivity (wagmi in prod, demo flag in mock) — the gate for trade/portfolio flows. */
  walletConnected: boolean;
  /** Proven wallet: SIWE sessions are their own wallet; DID sessions read /me.linkedWallet. */
  linkedWallet: string | null;
  /** Whether this session has a proven wallet and may trade. */
  canTrade: boolean;
  data?: LoginApiResult;
  /** Opens the login-method picker (Connect Wallet / DID / ...). */
  login: (options?: any | MouseEvent<any, any>) => void;
  /** Connect own wallet (Reown/SIWE). Called from the picker. */
  loginWallet?: () => void;
  /** Social login via DID OAuth. Called from the picker. */
  loginDid?: () => void;
  /** Link a self-custody wallet to a DID session (connect + SIWE proof). */
  linkWallet?: () => Promise<void>;
  /** Bare wallet connect (no login/link side effects). */
  connectWallet?: () => void;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthInterface>({
  isAuthLoading: false,
  isAuthed: false,
  walletConnected: false,
  linkedWallet: null,
  canTrade: false,
  data: undefined,
  login: () => {
    console.log('Auth disabled - login mock');
  },
  logout: async () => {
    console.log('Auth disabled - logout mock');
  },
});

export const useAuth = () => {
  return useContext(AuthContext);
};
